// ── Копіювання тексту в буфер обміну ─────────────────────
// navigator.clipboard вимагає secure context (HTTPS або localhost) —
// фолбек для решти випадків: тимчасове невидиме textarea +
// document.execCommand('copy') (сесія 2026-09-03, винесено з
// BookFullView.js у спільний модуль сесією 2026-10-25 — «Вибрані»).
function legacyCopyToClipboard(text) {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

// Повертає Promise<boolean> — чи вдалося скопіювати
export function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text)
      .then(() => true)
      .catch(() => legacyCopyToClipboard(text));
  }
  return Promise.resolve(legacyCopyToClipboard(text));
}
